/*
 * Enable Client changing
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { Injectable } from '@angular/core';

import { UserService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class CannotChangeClientGuard  {

  constructor(private userService: UserService) {
  }

  canActivate() {
    this.userService.disableClientChange();
    return true;
  }
}
